import type { Buyer } from 'types/buyer'
import type { Seller } from 'types/seller'

import styled from 'styled-components'

import copy from 'copy.json'
import { formatDate, formatPhoneNumber, formatNIP } from 'utils'

import Scroll from 'components/Scroll'
import Table from 'components/Table'
import EmailConfirmation from 'components/EmailConfirmation'
import Consents from 'components/Consents'

const text_form = copy.common.form

type Props = {
  currentUserData: Buyer | Seller
}

export default function UserDetails({ currentUserData }: Props) {
  const consentsArray = [
    { name: text_form.privacy_consent, agreed: currentUserData.privacy_consent_agree },
    { name: text_form.marketing_consent, agreed: currentUserData.marketing_consent_agree },
    {
      name: text_form.marketing_third_party_consent,
      agreed: currentUserData.marketing_third_party_consent_agree
    }
  ]

  return (
    <Scroll>
      <TableWrapper>
        <Table>
          <tbody>
            <tr>
              <td>{text_form.company_name}</td>
              <td>{currentUserData.company_name}</td>
            </tr>
            <tr>
              <td>{text_form.login}</td>
              <td>{currentUserData.business_id}</td>
            </tr>
            <tr>
              <td>{text_form.tax_identifier}</td>
              <td>{formatNIP(currentUserData.tax_identifier)}</td>
            </tr>
            {(currentUserData as Seller).concession_identifier && (
              <tr>
                <td>{text_form.concession_identifier}</td>
                <td>{(currentUserData as Seller).concession_identifier}</td>
              </tr>
            )}
            <tr>
              <td>{text_form.phone_nr}</td>
              <td>{formatPhoneNumber(currentUserData.phone_number)}</td>
            </tr>
            <tr>
              <td>{text_form.email}</td>
              <td>
                <EmailConfirmation
                  emailConfirmed={currentUserData.email_confirmed}
                  contactEmail={currentUserData.contact_email}
                />
              </td>
            </tr>
            <tr>
              <td>{text_form.consents}</td>
              <td>
                <Consents consents={consentsArray} />
              </td>
            </tr>
            <tr>
              <td>{text_form.created_date}</td>
              <td>{formatDate(currentUserData.created_date)}</td>
            </tr>
          </tbody>
        </Table>
      </TableWrapper>
    </Scroll>
  )
}

const space = '20px'
const TableWrapper = styled.div`
  display: flex;
  gap: 0 20px;
  flex-wrap: wrap;
  max-width: 650px;
  margin-bottom: 35px;

  > table {
    border-spacing: ${space} 0;
    border-collapse: separate;
    margin-left: -${space};
  }
`
